import './index.css';var Ee = Object.defineProperty;
var Re = (o, e, t) => e in o ? Ee(o, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : o[e] = t;
var le = (o, e, t) => Re(o, typeof e != "symbol" ? e + "" : e, t);
import { EditableConfigurablePanelLayout as zt, ResponsiveConfigurablePanelLayout as Pt, mapThemeToPanelVars as Lt, mapThemeToTabVars as Wt } from "@principal-ade/panels";
import { useState as _, useRef as U, useEffect as E, useCallback as w, useMemo as ne } from "react";
import { jsx as l, jsxs as b, Fragment as ce } from "react/jsx-runtime";
import { useTheme as ee } from "@principal-ade/industry-theme";
class De {
  constructor() {
    le(this, "storageKey", "panel-layouts");
  }
  async load(e) {
    try {
      const t = localStorage.getItem(`${this.storageKey}:${e}`);
      return t ? JSON.parse(t) : null;
    } catch (t) {
      return console.error(`Failed to load panel layout for ${e}:`, t), null;
    }
  }
  async save(e, t) {
    try {
      localStorage.setItem(
        `${this.storageKey}:${e}`,
        JSON.stringify(t)
      );
    } catch (r) {
      console.error(`Failed to save panel layout for ${e}:`, r);
    }
  }
}
function dt(o) {
  const {
    viewKey: e,
    defaultSizes: t,
    panelType: r,
    adapter: s = new De()
  } = o, [i, a] = _(t), [n, g] = _(o.collapsed), c = U(o.collapsed), x = U({}), p = U(null), h = U(null);
  E(() => {
    (async () => {
      const S = await s.load(e);
      S != null && S.sizes && (a(S.sizes), C(S.sizes));
    })();
  }, [e]);
  const C = w(
    (v) => {
      "left" in v && v.left > 0 && (x.current.left = v.left), "middle" in v && v.middle > 0 && (x.current.middle = v.middle), "right" in v && v.right > 0 && (x.current.right = v.right);
    },
    []
  ), f = w(
    (v) => {
      const S = x.current[v];
      if (S && S > 0)
        return S;
      if (v === "left" && "left" in t && t.left > 0)
        return t.left;
      if (v === "right" && "right" in t && t.right > 0)
        return t.right;
    },
    [t]
  ), d = U(t);
  E(() => {
    ("left" in t && t.left !== d.current.left || "middle" in t && "middle" in d.current && t.middle !== d.current.middle || "right" in t && t.right !== d.current.right) && (a(t), C(t), d.current = t);
  }, [t, C]), E(() => {
    const v = o.collapsed.left !== c.current.left, S = "right" in o.collapsed && "right" in c.current && o.collapsed.right !== c.current.right;
    (v || S) && (g(o.collapsed), c.current = { ...o.collapsed });
  }, [o.collapsed.left, o.collapsed.right]);
  const u = w(
    async (v) => {
      try {
        await s.save(e, { sizes: v });
      } catch (S) {
        console.error(
          `Failed to save panel preferences for ${e}:`,
          S
        );
      }
    },
    [e, s]
  ), y = w(
    (v) => {
      const S = { ...v };
      let k = !0;
      if ("left" in v) {
        const I = !!(n != null && n.left), W = v.left;
        if (I) {
          const $ = f("left");
          $ !== void 0 && $ > 0 ? S.left = $ : k = !1;
        } else W === 0 && (k = !1);
      }
      if (r === "three-panel" && "right" in v) {
        const I = !!(n != null && n.right), W = v.right;
        if (I) {
          const $ = f("right");
          $ !== void 0 && $ > 0 ? S.right = $ : k = !1;
        } else W === 0 && (k = !1);
      }
      if (a(S), C(S), p.current && (clearTimeout(p.current), p.current = null), !k) {
        h.current = null;
        return;
      }
      h.current = S, p.current = setTimeout(() => {
        const I = h.current;
        I && (u(I), h.current = null), p.current = null;
      }, 500);
    },
    [
      n,
      f,
      r,
      u,
      C
    ]
  );
  E(() => () => {
    if (p.current) {
      const v = h.current;
      v && (u(v), h.current = null), clearTimeout(p.current), p.current = null;
    }
  }, [u]);
  const L = w(async () => {
  }, []), q = w(async () => {
  }, []), z = w(async () => {
  }, []), A = w(async () => {
  }, []);
  return r === "three-panel" ? {
    type: "three-panel",
    sizes: i,
    collapsed: n,
    handlePanelResize: y,
    handleLeftCollapseComplete: L,
    handleLeftExpandComplete: q,
    handleRightCollapseComplete: z,
    handleRightExpandComplete: A
  } : {
    type: "two-panel",
    sizes: i,
    collapsed: n,
    handlePanelResize: y,
    handleLeftCollapseComplete: L,
    handleLeftExpandComplete: q
  };
}
class Me {
  constructor() {
    le(this, "PRESETS_KEY", "panel-layouts:workspace-presets");
    le(this, "REPO_STATE_PREFIX", "panel-layouts:repo-state:");
  }
  /**
   * Load all user-created workspace presets
   */
  async loadWorkspacePresets() {
    try {
      const e = localStorage.getItem(this.PRESETS_KEY);
      return e ? JSON.parse(e) : {};
    } catch (e) {
      return console.error("Failed to load workspace presets:", e), {};
    }
  }
  /**
   * Save workspace presets
   */
  async saveWorkspacePresets(e) {
    try {
      localStorage.setItem(this.PRESETS_KEY, JSON.stringify(e));
    } catch (t) {
      throw console.error("Failed to save workspace presets:", t), t;
    }
  }
  /**
   * Load repository-specific workspace state
   */
  async loadRepositoryState(e) {
    try {
      const t = `${this.REPO_STATE_PREFIX}${e}`, r = localStorage.getItem(t);
      return r ? JSON.parse(r) : null;
    } catch (t) {
      return console.error(
        `Failed to load repository state for ${e}:`,
        t
      ), null;
    }
  }
  /**
   * Save repository-specific workspace state
   */
  async saveRepositoryState(e, t) {
    try {
      const r = `${this.REPO_STATE_PREFIX}${e}`;
      localStorage.setItem(r, JSON.stringify(t));
    } catch (r) {
      throw console.error(
        `Failed to save repository state for ${e}:`,
        r
      ), r;
    }
  }
  /**
   * Load all repository states
   */
  async loadAllRepositoryStates() {
    try {
      const e = {};
      for (let t = 0; t < localStorage.length; t++) {
        const r = localStorage.key(t);
        if (r && r.startsWith(this.REPO_STATE_PREFIX)) {
          const s = r.substring(this.REPO_STATE_PREFIX.length), i = localStorage.getItem(r);
          if (i)
            try {
              e[s] = JSON.parse(i);
            } catch (a) {
              console.error(
                `Failed to parse repository state for ${s}:`,
                a
              );
            }
        }
      }
      return e;
    } catch (e) {
      return console.error("Failed to load all repository states:", e), {};
    }
  }
}
class O {
  /**
   * Configure a custom storage adapter (for Electron IPC or remote storage)
   */
  static setAdapter(e) {
    this.adapter = e;
  }
  /**
   * Get all workspace layouts (including built-in)
   */
  static async getWorkspaceLayouts() {
    const e = this.getBuiltInWorkspaceLayouts();
    return {
      ...await this.adapter.loadWorkspacePresets(),
      ...e
    };
  }
  /**
   * Get a specific workspace layout by ID
   */
  static async getWorkspaceLayout(e) {
    return (await this.getWorkspaceLayouts())[e] || null;
  }
  /**
   * Create a new workspace layout
   */
  static async createWorkspaceLayout(e) {
    const t = await this.adapter.loadWorkspacePresets(), r = this.generateWorkspaceId(e.name), s = {
      id: r,
      name: e.name,
      description: e.description,
      layout: e.layout,
      defaultSizes: e.defaultSizes,
      defaultCollapsed: e.defaultCollapsed,
      createdAt: Date.now(),
      updatedAt: Date.now(),
      isBuiltIn: !1
    }, i = {
      ...t,
      [r]: s
    };
    return await this.adapter.saveWorkspacePresets(i), s;
  }
  /**
   * Update an existing workspace layout
   */
  static async updateWorkspaceLayout(e, t) {
    const r = await this.adapter.loadWorkspacePresets(), s = r[e];
    if (!s)
      return console.error(`Workspace layout ${e} not found`), null;
    if (s.isBuiltIn)
      return console.error(`Cannot update built-in workspace layout ${e}`), null;
    const i = {
      ...s,
      ...t,
      id: e,
      // Preserve ID
      createdAt: s.createdAt,
      // Preserve creation time
      updatedAt: Date.now()
    }, a = {
      ...r,
      [e]: i
    };
    return await this.adapter.saveWorkspacePresets(a), i;
  }
  /**
   * Delete a workspace layout
   */
  static async deleteWorkspaceLayout(e) {
    const t = await this.adapter.loadWorkspacePresets(), r = t[e];
    if (!r)
      return console.error(`Workspace layout ${e} not found`), !1;
    if (r.isBuiltIn)
      return console.error(`Cannot delete built-in workspace layout ${e}`), !1;
    const s = { ...t };
    return delete s[e], await this.adapter.saveWorkspacePresets(s), !0;
  }
  /**
   * Get repository state (which workspace + current sizes/collapsed)
   */
  static async getRepositoryState(e) {
    return await this.adapter.loadRepositoryState(e);
  }
  /**
   * Set repository state (which workspace + current sizes/collapsed/layout)
   */
  static async setRepositoryState(e, t) {
    await this.adapter.saveRepositoryState(e, t);
  }
  /**
   * Update only sizes in repository state
   */
  static async updateRepositorySizes(e, t) {
    const r = await this.getRepositoryState(e);
    r && await this.setRepositoryState(e, {
      ...r,
      sizes: t
    });
  }
  /**
   * Update only collapsed state in repository state
   */
  static async updateRepositoryCollapsed(e, t) {
    const r = await this.getRepositoryState(e);
    r && await this.setRepositoryState(e, {
      ...r,
      collapsed: t
    });
  }
  /**
   * Check if repository state differs from workspace defaults
   */
  static hasStateDeviation(e, t) {
    const r = t.defaultSizes ? JSON.stringify(e.sizes) !== JSON.stringify(t.defaultSizes) : !1, s = t.defaultCollapsed ? JSON.stringify(e.collapsed) !== JSON.stringify(t.defaultCollapsed) : !1;
    return { hasSizeDeviation: r, hasCollapsedDeviation: s };
  }
  /**
   * Update workspace defaults from repository state
   */
  static async updateWorkspaceFromRepositoryState(e, t) {
    const r = await this.getWorkspaceLayout(e), s = await this.getRepositoryState(t);
    if (!r || !s || r.isBuiltIn) {
      console.error(
        "Cannot update built-in workspace or workspace/state not found"
      );
      return;
    }
    await this.updateWorkspaceLayout(e, {
      defaultSizes: s.sizes,
      defaultCollapsed: s.collapsed
    });
  }
  /**
   * Reset repository state to workspace defaults
   */
  static async resetRepositoryToWorkspaceDefaults(e, t) {
    const r = await this.getWorkspaceLayout(t);
    if (!r) {
      console.error(`Workspace ${t} not found`);
      return;
    }
    const s = await this.getRepositoryState(e);
    s && await this.setRepositoryState(e, {
      ...s,
      sizes: r.defaultSizes || { left: 20, middle: 45, right: 35 },
      collapsed: r.defaultCollapsed || { left: !1, right: !1 }
    });
  }
  /**
   * Check if a layout matches a workspace layout
   */
  static isLayoutMatchingWorkspace(e, t) {
    return this.areLayoutsEqual(e, t.layout);
  }
  /**
   * Find workspace ID that matches the given layout
   */
  static async findMatchingWorkspace(e) {
    const t = await this.getWorkspaceLayouts();
    for (const [r, s] of Object.entries(t))
      if (this.isLayoutMatchingWorkspace(e, s))
        return r;
    return null;
  }
  /**
   * Deep comparison of two panel layouts
   */
  static areLayoutsEqual(e, t) {
    return JSON.stringify(e) === JSON.stringify(t);
  }
  /**
   * Generate a unique ID from a workspace name
   */
  static generateWorkspaceId(e) {
    return `${e.toLowerCase().replace(/[^a-z0-9]+/g, "-")}-${Date.now()}`;
  }
  /**
   * Get built-in workspace layouts
   */
  static getBuiltInWorkspaceLayouts() {
    const e = Date.now();
    return {
      "project-management": {
        id: "project-management",
        name: "Project Management",
        description: "Tasks, dependencies, issues, file tree, docs, drawings, multi terminal, city visualization, code viewer, markdown slides, and excalidraw",
        layout: {
          left: {
            type: "tabs",
            panels: [
              "tasks",
              "dependencies",
              "gitIssues",
              "fileTree",
              "docs",
              "drawings"
            ],
            config: { defaultActiveTab: 0, tabPosition: "top" }
          },
          middle: "multiTerminal",
          right: {
            type: "tabs",
            panels: [
              "cityVisualization",
              "codeViewer",
              "markdownViewer",
              "excalidrawDiagram"
            ],
            config: { defaultActiveTab: 0, tabPosition: "top" }
          }
        },
        defaultSizes: { left: 20, middle: 45, right: 35 },
        defaultCollapsed: { left: !1, right: !1 },
        createdAt: e,
        updatedAt: e,
        isBuiltIn: !0
      },
      "code-review": {
        id: "code-review",
        name: "Code Review",
        description: "Git changes, pull requests, and file tree on left, git diff and code viewer in middle, city map on right",
        layout: {
          left: {
            type: "tabs",
            panels: ["gitChanges", "gitPullRequests", "fileTree"],
            config: { defaultActiveTab: 0, tabPosition: "top" }
          },
          middle: {
            type: "tabs",
            panels: ["gitDiff", "codeViewer"],
            config: { defaultActiveTab: 0, tabPosition: "top" }
          },
          right: "cityVisualization"
        },
        defaultSizes: { left: 20, middle: 50, right: 30 },
        defaultCollapsed: { left: !1, right: !1 },
        createdAt: e,
        updatedAt: e,
        isBuiltIn: !0
      },
      documentation: {
        id: "documentation",
        name: "Documentation",
        description: "Docs, markdown viewer, and code viewer",
        layout: {
          left: "docs",
          middle: "markdownViewer",
          right: "codeViewer"
        },
        defaultSizes: { left: 20, middle: 50, right: 30 },
        defaultCollapsed: { left: !1, right: !0 },
        createdAt: e,
        updatedAt: e,
        isBuiltIn: !0
      },
      "agent-work": {
        id: "agent-work",
        name: "Agent Work",
        description: "Tasks, agent sessions, file tree, agent context, git changes, docs, multi terminal, city map, agent events, code viewer, and markdown slides",
        layout: {
          left: {
            type: "tabs",
            panels: [
              "tasks",
              "agentSessions",
              "fileTree",
              "agentContext",
              "gitChanges",
              "docs"
            ],
            config: { defaultActiveTab: 0, tabPosition: "top" }
          },
          middle: "multiTerminal",
          right: {
            type: "tabs",
            panels: [
              "cityVisualization",
              "agentEvents",
              "codeViewer",
              "markdownViewer"
            ],
            config: { defaultActiveTab: 0, tabPosition: "top" }
          }
        },
        defaultSizes: { left: 20, middle: 45, right: 35 },
        defaultCollapsed: { left: !1, right: !1 },
        createdAt: e,
        updatedAt: e,
        isBuiltIn: !0
      },
      "quality-check": {
        id: "quality-check",
        name: "Quality Check",
        description: "Package information, tools, and dependencies on left; city visualization map in middle; multi terminal and code viewer on right (collapsed)",
        layout: {
          left: {
            type: "tabs",
            panels: ["packageInfo", "tools", "dependencies"],
            config: { defaultActiveTab: 0, tabPosition: "top" }
          },
          middle: "cityVisualization",
          right: {
            type: "tabs",
            panels: ["multiTerminal", "codeViewer"],
            config: { defaultActiveTab: 0, tabPosition: "top" }
          }
        },
        defaultSizes: { left: 20, middle: 45, right: 35 },
        defaultCollapsed: { left: !1, right: !0 },
        createdAt: e,
        updatedAt: e,
        isBuiltIn: !0
      },
      drawing: {
        id: "drawing",
        name: "Drawing",
        description: "Drawings and docs, excalidraw diagram, multi terminal and markdown viewer",
        layout: {
          left: {
            type: "tabs",
            panels: ["drawings", "docs"],
            config: { defaultActiveTab: 0, tabPosition: "top" }
          },
          middle: "excalidrawDiagram",
          right: {
            type: "tabs",
            panels: ["multiTerminal", "markdownViewer"],
            config: { defaultActiveTab: 0, tabPosition: "top" }
          }
        },
        defaultSizes: { left: 20, middle: 50, right: 30 },
        defaultCollapsed: { left: !1, right: !0 },
        createdAt: e,
        updatedAt: e,
        isBuiltIn: !0
      },
      "old-school": {
        id: "old-school",
        name: "Old School",
        description: "File tree, search, git changes, and docs on left; code viewer and markdown viewer in middle; multi terminal and city map on right (collapsed)",
        layout: {
          left: {
            type: "tabs",
            panels: ["fileTree", "search", "gitChanges", "docs"],
            config: { defaultActiveTab: 0, tabPosition: "top" }
          },
          middle: {
            type: "tabs",
            panels: ["codeViewer", "markdownViewer"],
            config: { defaultActiveTab: 0, tabPosition: "top" }
          },
          right: {
            type: "tabs",
            panels: ["multiTerminal", "cityVisualization"],
            config: { defaultActiveTab: 0, tabPosition: "top" }
          }
        },
        defaultSizes: { left: 20, middle: 50, right: 30 },
        defaultCollapsed: { left: !1, right: !0 },
        createdAt: e,
        updatedAt: e,
        isBuiltIn: !0
      },
      "principal-office": {
        id: "principal-office",
        name: "Principal Office",
        description: "Alexandria docs on left, MDX editor in middle, multi terminal on right",
        layout: {
          left: "docs",
          middle: "mdxEditor",
          right: "multiTerminal"
        },
        defaultSizes: { left: 20, middle: 50, right: 30 },
        defaultCollapsed: { left: !1, right: !1 },
        createdAt: e,
        updatedAt: e,
        isBuiltIn: !0
      }
    };
  }
  /**
   * Initialize workspace layouts with built-in defaults if none exist
   */
  static async initializeWorkspaceLayouts() {
    const e = await this.adapter.loadWorkspacePresets();
    Object.keys(e).length;
  }
}
le(O, "adapter", new Me());
function pt(o = {}) {
  const { repositoryKey: e, autoInitialize: t = !1, defaultWorkspaceId: r } = o, [s, i] = _(
    {}
  ), [a, n] = _(null), [g, c] = _(null), [x, p] = _(!0), [h, C] = _(null), f = w(async () => {
    try {
      p(!0), C(null);
      const k = await O.getWorkspaceLayouts();
      if (i(k), e) {
        let I = await O.getRepositoryState(e);
        if (!I && t) {
          const W = r || "project-management", $ = await O.getWorkspaceLayout(W);
          $ && (I = {
            workspaceId: W,
            sizes: $.defaultSizes || {
              left: 20,
              middle: 45,
              right: 35
            },
            collapsed: $.defaultCollapsed || {
              left: !1,
              right: !1
            }
          }, await O.setRepositoryState(
            e,
            I
          ));
        }
        if (n(I), I != null && I.workspaceId) {
          const W = await O.getWorkspaceLayout(
            I.workspaceId
          );
          c(W);
        } else
          c(null);
      }
    } catch (k) {
      C(k), console.error("Failed to load workspace data:", k);
    } finally {
      p(!1);
    }
  }, [e, t, r]);
  E(() => {
    f();
  }, [f]);
  const d = w(
    async (k) => await O.getWorkspaceLayout(k),
    []
  ), u = w(
    async (k) => {
      const I = await O.createWorkspaceLayout(k);
      return await f(), I;
    },
    [f]
  ), y = w(
    async (k, I) => {
      const W = await O.updateWorkspaceLayout(k, I);
      return await f(), W;
    },
    [f]
  ), L = w(
    async (k) => {
      const I = await O.deleteWorkspaceLayout(k);
      return I && await f(), I;
    },
    [f]
  ), q = w(
    async (k) => {
      if (!e) {
        console.error("Cannot apply workspace without repositoryKey");
        return;
      }
      const I = await O.getWorkspaceLayout(k);
      if (!I) {
        console.error(`Workspace ${k} not found`);
        return;
      }
      const W = {
        workspaceId: k,
        sizes: I.defaultSizes || { left: 20, middle: 45, right: 35 },
        collapsed: I.defaultCollapsed || {
          left: !1,
          right: !1
        }
      };
      await O.setRepositoryState(e, W), await f();
    },
    [e, f]
  ), z = w(
    async (k) => {
      if (!e) {
        console.error("Cannot update sizes without repositoryKey");
        return;
      }
      await O.updateRepositorySizes(e, k), await f();
    },
    [e, f]
  ), A = w(
    async (k) => {
      if (!e) {
        console.error("Cannot update collapsed without repositoryKey");
        return;
      }
      await O.updateRepositoryCollapsed(
        e,
        k
      ), await f();
    },
    [e, f]
  ), v = w(async () => {
    if (!e || !(a != null && a.workspaceId)) {
      console.error("Cannot reset without repositoryKey and active workspace");
      return;
    }
    await O.resetRepositoryToWorkspaceDefaults(
      e,
      a.workspaceId
    ), await f();
  }, [e, a == null ? void 0 : a.workspaceId, f]), S = w(async () => {
    await f();
  }, [f]);
  return {
    workspaces: s,
    repositoryState: a,
    activeWorkspace: g,
    loading: x,
    error: h,
    getWorkspace: d,
    createWorkspace: u,
    updateWorkspace: y,
    deleteWorkspace: L,
    applyWorkspace: q,
    updateSizes: z,
    updateCollapsed: A,
    resetToDefaults: v,
    refresh: S
  };
}
function ut(o = {}) {
  const {
    initialFocus: e = null,
    collapsed: t = {},
    panelType: r = "three-panel",
    onFocusChange: s,
    events: i,
    getPanelId: a
  } = o, [n, g] = _(
    e
  ), c = w(
    (d) => {
      const u = n;
      if (g(d), s == null || s(d), i && a) {
        if (u) {
          const L = a(u);
          L && i.emit({
            type: "panel:blur",
            source: "panel-layouts",
            timestamp: Date.now(),
            payload: {
              panelId: L,
              panelSlot: u,
              nextPanelId: a(d)
            }
          });
        }
        const y = a(d);
        y && i.emit({
          type: "panel:focus",
          source: "panel-layouts",
          timestamp: Date.now(),
          payload: {
            panelId: y,
            panelSlot: d,
            source: "keyboard-shortcut"
          }
        });
      }
    },
    [n, s, i, a]
  ), x = w(() => {
    const d = n;
    if (g(null), s == null || s(null), i && a && d) {
      const u = a(d);
      u && i.emit({
        type: "panel:blur",
        source: "panel-layouts",
        timestamp: Date.now(),
        payload: {
          panelId: u,
          panelSlot: d
        }
      });
    }
  }, [n, s, i, a]), p = w(() => {
    const d = [];
    return t.left || d.push("left"), d.push("middle"), r === "three-panel" && !t.right && d.push("right"), d;
  }, [t, r]), h = w(() => {
    const d = p();
    if (d.length === 0) return;
    if (n === null) {
      c(d[0]);
      return;
    }
    const u = d.indexOf(n);
    if (u === -1) {
      c(d[0]);
      return;
    }
    const y = (u + 1) % d.length;
    c(d[y]);
  }, [n, p, c]), C = w(() => {
    const d = p();
    if (d.length === 0) return;
    if (n === null) {
      c(d[d.length - 1]);
      return;
    }
    const u = d.indexOf(n);
    if (u === -1) {
      c(d[d.length - 1]);
      return;
    }
    const y = u === 0 ? d.length - 1 : u - 1;
    c(d[y]);
  }, [n, p, c]), f = w(
    (d) => n === d,
    [n]
  );
  return {
    focusedPanel: n,
    setFocus: c,
    clearFocus: x,
    focusNext: h,
    focusPrevious: C,
    isFocused: f
  };
}
function ft(o) {
  const {
    enabled: e = !0,
    focusedPanel: t,
    collapsed: r,
    panelType: s,
    setFocus: i,
    onExpand: a,
    onCollapse: n
  } = o, g = U(t), c = U(r), x = U(s);
  E(() => {
    g.current = t;
  }, [t]), E(() => {
    c.current = r;
  }, [r]), E(() => {
    x.current = s;
  }, [s]);
  const p = w(
    (h) => {
      if (!h.altKey || h.ctrlKey || h.metaKey || h.shiftKey)
        return;
      const C = h.code, f = g.current, d = c.current, u = x.current;
      C === "Digit1" || C === "Numpad1" ? (h.preventDefault(), d.left ? a("left") : f !== "left" ? i("left") : (n("left"), i("middle"))) : C === "Digit2" || C === "Numpad2" ? (h.preventDefault(), i("middle")) : (C === "Digit3" || C === "Numpad3") && u === "three-panel" && (h.preventDefault(), d.right ? a("right") : f !== "right" ? i("right") : (n("right"), i("middle")));
    },
    [i, a, n]
  );
  E(() => {
    if (e)
      return window.addEventListener("keydown", p), () => {
        window.removeEventListener("keydown", p);
      };
  }, [e, p]);
}
function gt(o, e, t, r) {
  E(() => {
    const s = e.on(
      "panel:focus",
      (a) => {
        a.payload.panelId === o && t();
      }
    );
    let i;
    return r && (i = e.on(
      "panel:blur",
      (a) => {
        a.payload.panelId === o && r();
      }
    )), () => {
      s(), i == null || i();
    };
  }, [o, e, t, r]);
}
const ht = ({
  isFocused: o,
  className: e = "",
  style: t = {}
}) => {
  if (!o)
    return null;
  const r = {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    pointerEvents: "none",
    border: "2px solid var(--panel-focus-border-color, #0066cc)",
    borderRadius: "4px",
    boxShadow: "0 0 0 1px var(--panel-focus-shadow-color, rgba(0, 102, 204, 0.2))",
    zIndex: 1e3,
    transition: "opacity 0.15s ease-in-out",
    ...t
  };
  return /* @__PURE__ */ l(
    "div",
    {
      className: `panel-focus-indicator ${e}`,
      style: r,
      role: "presentation",
      "aria-hidden": "true"
    }
  );
}, ge = "focus-mode-overlay-keyframes", je = () => {
  if (typeof document > "u" || document.getElementById(ge)) return;
  const o = document.createElement("style");
  o.id = ge, o.textContent = `
    @keyframes focus-overlay-vignette-drift {
      0%, 100% {
        background-position: 50% 50%;
        transform: scale(1);
      }
      25% {
        background-position: 20% 30%;
        transform: scale(1.1);
      }
      50% {
        background-position: 80% 70%;
        transform: scale(1.05);
      }
      75% {
        background-position: 70% 20%;
        transform: scale(1.15);
      }
    }

    @keyframes focus-overlay-radial-breathing {
      0%, 100% {
        opacity: 1;
        transform: scale(1);
      }
      50% {
        opacity: 0.4;
        transform: scale(1.3);
      }
    }

    @keyframes focus-overlay-snowfall-1 {
      from { background-position: 0px 0px; }
      to { background-position: 0px 150px; }
    }
    @keyframes focus-overlay-snowfall-2 {
      from { background-position: 0px 0px; }
      to { background-position: 0px 150px; }
    }
    @keyframes focus-overlay-snowfall-3 {
      from { background-position: 0px 0px; }
      to { background-position: 0px 150px; }
    }

  `, document.head.appendChild(o);
}, mt = ({
  active: o,
  variant: e = "soft-fade",
  effects: t = [],
  opacity: r = 0.95,
  animationDuration: s = 300,
  cascadeDelay: i = 0,
  color: a,
  hideOnHover: n = !0,
  className: g = "",
  style: c = {}
}) => {
  const { theme: x } = ee(), [p, h] = _(!1), [C, f] = _(!1), d = U(null);
  E(() => {
    je();
  }, []), E(() => {
    if (!n || !o) {
      f(!1);
      return;
    }
    const te = (H) => {
      if (d.current) {
        const M = d.current.getBoundingClientRect(), oe = H.clientX >= M.left && H.clientX <= M.right && H.clientY >= M.top && H.clientY <= M.bottom;
        f(oe);
      }
    };
    return document.addEventListener("mousemove", te), () => document.removeEventListener("mousemove", te);
  }, [n, o]), E(() => {
    if (o) {
      const te = setTimeout(() => h(!0), i);
      return () => clearTimeout(te);
    } else
      h(!1);
  }, [o, i]);
  const u = a || x.colors.background, y = () => {
    switch (e) {
      case "soft-fade":
        return {
          backgroundColor: u,
          opacity: p ? r : 0,
          transition: `opacity ${s}ms ease-out`
        };
      case "cascading-fade":
        return {
          backgroundColor: u,
          opacity: p ? r : 0,
          transition: `opacity ${s}ms ease-out`,
          transitionDelay: p ? "0ms" : `${i}ms`
        };
      default:
        return {
          backgroundColor: u,
          opacity: p ? r : 0,
          transition: `opacity ${s}ms ease-out`
        };
    }
  }, L = n && C, q = {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    pointerEvents: "none",
    zIndex: 999,
    overflow: "hidden",
    ...y(),
    // Override opacity when hovered
    ...L ? { opacity: 0 } : {},
    ...c
  }, z = t.includes("vignette-drift"), A = t.includes("radial-breathing"), v = t.includes("snowfall"), S = (te, H) => {
    const M = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(te);
    if (!M) return `rgba(255, 255, 255, ${H})`;
    const oe = parseInt(M[1], 16), V = parseInt(M[2], 16), Y = parseInt(M[3], 16);
    return `rgba(${oe}, ${V}, ${Y}, ${H})`;
  }, k = x.colors.primary, I = {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    pointerEvents: "none",
    opacity: p ? 1 : 0,
    transition: `opacity ${s}ms ease-out`,
    background: `radial-gradient(circle at 50% 50%, ${S(k, 0.12)} 0%, ${S(k, 0.06)} 25%, transparent 50%)`,
    backgroundSize: "150% 150%",
    animation: p ? "focus-overlay-vignette-drift 12s ease-in-out infinite" : "none"
  }, W = {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    pointerEvents: "none",
    opacity: p ? 1 : 0,
    transition: `opacity ${s}ms ease-out`,
    background: `radial-gradient(circle at center, ${S(k, 0.15)} 0%, ${S(k, 0.06)} 30%, transparent 55%)`,
    animation: p ? "focus-overlay-radial-breathing 4s ease-in-out infinite" : "none"
  }, $ = S(k, 0.6), T = S(k, 0.4), P = S(k, 0.25), B = {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    pointerEvents: "none",
    opacity: p ? 1 : 0,
    transition: `opacity ${s}ms ease-out`
  }, se = {
    ...B,
    background: `
      radial-gradient(circle, ${$} 0%, ${$} 3px, transparent 3px),
      radial-gradient(circle, ${$} 0%, ${$} 3px, transparent 3px),
      radial-gradient(circle, ${$} 0%, ${$} 3px, transparent 3px),
      radial-gradient(circle, ${$} 0%, ${$} 3px, transparent 3px)
    `,
    backgroundSize: "150px 150px",
    backgroundPosition: "10px 20px, 60px 80px, 110px 40px, 40px 120px",
    animation: p ? "focus-overlay-snowfall-1 4s linear infinite" : "none"
  }, G = {
    ...B,
    background: `
      radial-gradient(circle, ${T} 0%, ${T} 2px, transparent 2px),
      radial-gradient(circle, ${T} 0%, ${T} 2px, transparent 2px),
      radial-gradient(circle, ${T} 0%, ${T} 2px, transparent 2px),
      radial-gradient(circle, ${T} 0%, ${T} 2px, transparent 2px),
      radial-gradient(circle, ${T} 0%, ${T} 2px, transparent 2px)
    `,
    backgroundSize: "150px 150px",
    backgroundPosition: "30px 10px, 90px 60px, 15px 100px, 120px 30px, 70px 130px",
    animation: p ? "focus-overlay-snowfall-2 7s linear infinite" : "none"
  }, K = {
    ...B,
    background: `
      radial-gradient(circle, ${P} 0%, ${P} 1.5px, transparent 1.5px),
      radial-gradient(circle, ${P} 0%, ${P} 1.5px, transparent 1.5px),
      radial-gradient(circle, ${P} 0%, ${P} 1.5px, transparent 1.5px),
      radial-gradient(circle, ${P} 0%, ${P} 1.5px, transparent 1.5px),
      radial-gradient(circle, ${P} 0%, ${P} 1.5px, transparent 1.5px),
      radial-gradient(circle, ${P} 0%, ${P} 1.5px, transparent 1.5px)
    `,
    backgroundSize: "150px 150px",
    backgroundPosition: "20px 5px, 80px 45px, 45px 90px, 130px 20px, 5px 70px, 100px 110px",
    animation: p ? "focus-overlay-snowfall-3 12s linear infinite" : "none"
  };
  return /* @__PURE__ */ b(
    "div",
    {
      ref: d,
      className: `focus-mode-overlay focus-mode-overlay--${e} ${g}`,
      style: q,
      role: "presentation",
      "aria-hidden": "true",
      "data-active": o,
      "data-variant": e,
      children: [
        z && /* @__PURE__ */ l(
          "div",
          {
            className: "focus-mode-overlay__vignette-drift",
            style: I
          }
        ),
        A && /* @__PURE__ */ l(
          "div",
          {
            className: "focus-mode-overlay__radial-breathing",
            style: W
          }
        ),
        v && /* @__PURE__ */ b(ce, { children: [
          /* @__PURE__ */ l(
            "div",
            {
              className: "focus-mode-overlay__snowfall-layer-3",
              style: K
            }
          ),
          /* @__PURE__ */ l(
            "div",
            {
              className: "focus-mode-overlay__snowfall-layer-2",
              style: G
            }
          ),
          /* @__PURE__ */ l(
            "div",
            {
              className: "focus-mode-overlay__snowfall-layer-1",
              style: se
            }
          )
        ] })
      ]
    }
  );
}, xe = ({
  value: o,
  onChange: e,
  onSubmit: t,
  onClose: r,
  onHistoryPrevious: s,
  onHistoryNext: i,
  mode: a,
  status: n,
  placeholder: g = "What would you like to do?",
  disabled: c = !1,
  autoFocus: x = !0,
  agentAvailable: p = !0,
  showAutocomplete: h = !1,
  autocompleteItemCount: C = 0,
  onAutocompleteNext: f,
  onAutocompletePrevious: d,
  onAutocompleteAccept: u
}) => {
  const { theme: y } = ee(), L = U(null);
  E(() => {
    x && L.current && L.current.focus();
  }, [x]);
  const q = (A) => {
    switch (A.stopPropagation(), A.key) {
      case "Enter":
        A.preventDefault(), h && C === 1 && u ? u(!0) : t();
        break;
      case "Escape":
        A.preventDefault(), r();
        break;
      case "Tab":
        h && u && (A.preventDefault(), u());
        break;
      case "ArrowUp":
        A.preventDefault(), h && d ? d() : s();
        break;
      case "ArrowDown":
        A.preventDefault(), h && f ? f() : i();
        break;
    }
  }, z = n === "thinking" || n === "executing";
  return /* @__PURE__ */ b(
    "div",
    {
      style: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        padding: "12px 16px",
        backgroundColor: y.colors.background,
        borderBottom: `1px solid ${y.colors.border}`
      },
      children: [
        /* @__PURE__ */ l(
          "span",
          {
            style: {
              color: a === "quick-command" ? y.colors.info : p ? y.colors.primary : y.colors.textMuted,
              fontFamily: y.fonts.monospace,
              fontSize: y.fontSizes[1],
              userSelect: "none",
              display: "flex",
              alignItems: "center"
            },
            children: a === "quick-command" ? /* @__PURE__ */ b(
              "svg",
              {
                width: "16",
                height: "16",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                children: [
                  /* @__PURE__ */ l("polyline", { points: "4 17 10 11 4 5" }),
                  /* @__PURE__ */ l("line", { x1: "12", y1: "19", x2: "20", y2: "19" })
                ]
              }
            ) : p ? /* @__PURE__ */ b(
              "svg",
              {
                width: "16",
                height: "16",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                children: [
                  /* @__PURE__ */ l("rect", { x: "3", y: "11", width: "18", height: "10", rx: "2" }),
                  /* @__PURE__ */ l("circle", { cx: "12", cy: "5", r: "2" }),
                  /* @__PURE__ */ l("path", { d: "M12 7v4" }),
                  /* @__PURE__ */ l("line", { x1: "8", y1: "16", x2: "8", y2: "16" }),
                  /* @__PURE__ */ l("line", { x1: "16", y1: "16", x2: "16", y2: "16" })
                ]
              }
            ) : ">"
          }
        ),
        /* @__PURE__ */ l(
          "input",
          {
            ref: L,
            "data-agent-command-palette-input": !0,
            type: "text",
            value: o,
            onChange: (A) => e(A.target.value),
            onKeyDown: q,
            placeholder: g,
            disabled: c || z,
            style: {
              flex: 1,
              backgroundColor: "transparent",
              border: "none",
              outline: "none",
              color: y.colors.text,
              fontFamily: y.fonts.monospace,
              fontSize: y.fontSizes[1],
              caretColor: y.colors.primary
            }
          }
        ),
        z && /* @__PURE__ */ b(
          "span",
          {
            style: {
              color: y.colors.info,
              fontSize: y.fontSizes[0],
              display: "flex",
              alignItems: "center",
              gap: "4px"
            },
            children: [
              /* @__PURE__ */ l(
                "span",
                {
                  style: {
                    display: "inline-block",
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    backgroundColor: y.colors.info,
                    animation: "pulse 1s ease-in-out infinite"
                  }
                }
              ),
              n === "thinking" ? "Thinking..." : "Executing..."
            ]
          }
        ),
        !z && /* @__PURE__ */ l(
          "kbd",
          {
            style: {
              padding: "2px 6px",
              backgroundColor: y.colors.backgroundSecondary,
              borderRadius: "3px",
              border: `1px solid ${y.colors.border}`,
              fontSize: y.fontSizes[0],
              color: y.colors.textMuted
            },
            children: "Alt+P"
          }
        )
      ]
    }
  );
};
xe.displayName = "AgentCommandInput";
const qe = ({ status: o }) => {
  const { theme: e } = ee(), t = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: "16px",
    height: "16px",
    fontSize: e.fontSizes[0]
  };
  switch (o) {
    case "pending":
      return /* @__PURE__ */ l("span", { style: { ...t, color: e.colors.textMuted }, children: "○" });
    case "running":
      return /* @__PURE__ */ l(
        "span",
        {
          style: {
            ...t,
            color: e.colors.info,
            animation: "spin 1s linear infinite"
          },
          children: "◐"
        }
      );
    case "success":
      return /* @__PURE__ */ l("span", { style: { ...t, color: e.colors.success }, children: "✓" });
    case "error":
      return /* @__PURE__ */ l("span", { style: { ...t, color: e.colors.error }, children: "✗" });
  }
}, Ne = (o) => {
  const e = Object.entries(o);
  return e.length === 0 ? "" : e.map(([t, r]) => t === "args" && Array.isArray(r) ? r.join(", ") : typeof r == "string" ? `"${r}"` : JSON.stringify(r)).join(", ");
}, Fe = ({ tool: o, compact: e }) => {
  const { theme: t } = ee(), r = Ne(o.args);
  return /* @__PURE__ */ b(
    "div",
    {
      style: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        padding: e ? "4px 0" : "8px 0",
        fontFamily: t.fonts.monospace,
        fontSize: t.fontSizes[1]
      },
      children: [
        /* @__PURE__ */ l(qe, { status: o.status }),
        /* @__PURE__ */ b("span", { style: { color: t.colors.text }, children: [
          o.name,
          r && /* @__PURE__ */ b("span", { style: { color: t.colors.textMuted }, children: [
            "(",
            r,
            ")"
          ] })
        ] }),
        o.status === "running" && /* @__PURE__ */ l(
          "span",
          {
            style: {
              marginLeft: "auto",
              color: t.colors.info,
              fontSize: t.fontSizes[0]
            },
            children: "[running]"
          }
        ),
        o.status === "success" && /* @__PURE__ */ l(
          "span",
          {
            style: {
              marginLeft: "auto",
              color: t.colors.success,
              fontSize: t.fontSizes[0]
            },
            children: "[done]"
          }
        ),
        o.status === "error" && /* @__PURE__ */ l(
          "span",
          {
            style: {
              marginLeft: "auto",
              color: t.colors.error,
              fontSize: t.fontSizes[0]
            },
            title: o.error,
            children: "[error]"
          }
        )
      ]
    }
  );
}, ke = ({
  tools: o,
  compact: e = !1
}) => {
  const { theme: t } = ee();
  return o.length === 0 ? null : /* @__PURE__ */ l(
    "div",
    {
      style: {
        padding: e ? "8px 16px" : "12px 16px",
        backgroundColor: t.colors.backgroundSecondary,
        borderRadius: "4px",
        margin: "8px 16px"
      },
      children: o.map((r) => /* @__PURE__ */ l(Fe, { tool: r, compact: e }, r.id))
    }
  );
};
ke.displayName = "ToolExecutionList";
const be = ({
  response: o,
  streaming: e = !1
}) => {
  const { theme: t } = ee();
  if (!o)
    return null;
  const r = o.toLowerCase().startsWith("error"), s = o.toLowerCase().startsWith("done") || o.toLowerCase().startsWith("executed");
  return /* @__PURE__ */ b(
    "div",
    {
      style: {
        padding: "12px 16px",
        color: r ? t.colors.error : s ? t.colors.success : t.colors.text,
        fontSize: t.fontSizes[1],
        display: "flex",
        alignItems: "center",
        gap: "8px"
      },
      children: [
        s && /* @__PURE__ */ l("span", { children: "✓" }),
        r && /* @__PURE__ */ l("span", { children: "✗" }),
        /* @__PURE__ */ b("span", { children: [
          o,
          e && /* @__PURE__ */ l(
            "span",
            {
              style: {
                display: "inline-block",
                width: "2px",
                height: "14px",
                backgroundColor: t.colors.primary,
                marginLeft: "2px",
                animation: "blink 1s step-end infinite"
              }
            }
          )
        ] })
      ]
    }
  );
};
be.displayName = "AgentResponseDisplay";
function he({
  text: o,
  matchedIndices: e,
  highlightColor: t
}) {
  if (!e.length)
    return /* @__PURE__ */ l(ce, { children: o });
  const r = new Set(e), s = o.split("");
  return /* @__PURE__ */ l(ce, { children: s.map((i, a) => /* @__PURE__ */ l(
    "span",
    {
      style: {
        color: r.has(a) ? t : "inherit",
        fontWeight: r.has(a) ? 600 : "inherit"
      },
      children: i
    },
    a
  )) });
}
const we = ({
  matches: o,
  argumentMatches: e = [],
  currentArg: t,
  isEnteringArgs: r = !1,
  selectedIndex: s,
  onSelect: i,
  maxVisible: a = 6
}) => {
  const { theme: n } = ee(), g = U(null), c = U(null);
  if (E(() => {
    c.current && g.current && c.current.scrollIntoView({
      block: "nearest",
      behavior: "smooth"
    });
  }, [s]), r && e.length > 0) {
    const C = 40 * a;
    return /* @__PURE__ */ b(
      "div",
      {
        ref: g,
        style: {
          maxHeight: `${C}px`,
          overflowY: "auto",
          borderTop: `1px solid ${n.colors.border}`
        },
        children: [
          t && /* @__PURE__ */ b(
            "div",
            {
              style: {
                padding: "8px 16px",
                fontSize: n.fontSizes[0],
                color: n.colors.textMuted,
                backgroundColor: n.colors.backgroundSecondary,
                borderBottom: `1px solid ${n.colors.border}`
              },
              children: [
                /* @__PURE__ */ l("span", { style: { color: n.colors.textSecondary }, children: t.name }),
                t.description && /* @__PURE__ */ b("span", { style: { marginLeft: "8px" }, children: [
                  "— ",
                  t.description
                ] })
              ]
            }
          ),
          e.map((f, d) => {
            const u = d === s;
            return /* @__PURE__ */ b(
              "div",
              {
                ref: u ? c : void 0,
                onClick: () => i(d),
                style: {
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  padding: "8px 16px",
                  cursor: "pointer",
                  backgroundColor: u ? n.colors.backgroundSecondary : "transparent",
                  borderLeft: u ? `2px solid ${n.colors.primary}` : "2px solid transparent",
                  transition: "background-color 100ms ease"
                },
                onMouseEnter: (y) => {
                  u || (y.currentTarget.style.backgroundColor = n.colors.backgroundSecondary);
                },
                onMouseLeave: (y) => {
                  u || (y.currentTarget.style.backgroundColor = "transparent");
                },
                children: [
                  /* @__PURE__ */ l(
                    "span",
                    {
                      style: {
                        fontFamily: n.fonts.monospace,
                        fontSize: n.fontSizes[1],
                        color: n.colors.text,
                        flex: 1
                      },
                      children: /* @__PURE__ */ l(
                        he,
                        {
                          text: f.option,
                          matchedIndices: f.matchedIndices,
                          highlightColor: n.colors.primary
                        }
                      )
                    }
                  ),
                  u && /* @__PURE__ */ l(
                    "kbd",
                    {
                      style: {
                        padding: "2px 6px",
                        backgroundColor: n.colors.backgroundTertiary,
                        borderRadius: "3px",
                        border: `1px solid ${n.colors.border}`,
                        fontSize: n.fontSizes[0],
                        color: n.colors.textMuted,
                        flexShrink: 0
                      },
                      children: "Tab"
                    }
                  )
                ]
              },
              `${f.option}-${d}`
            );
          })
        ]
      }
    );
  }
  if (o.length === 0)
    return null;
  const p = 48 * a;
  return /* @__PURE__ */ l(
    "div",
    {
      ref: g,
      style: {
        maxHeight: `${p}px`,
        overflowY: "auto",
        borderTop: `1px solid ${n.colors.border}`
      },
      children: o.map((h, C) => {
        const f = C === s, d = h.command;
        return /* @__PURE__ */ b(
          "div",
          {
            ref: f ? c : void 0,
            onClick: () => i(C),
            style: {
              display: "flex",
              alignItems: "center",
              gap: "12px",
              padding: "10px 16px",
              cursor: "pointer",
              backgroundColor: f ? n.colors.backgroundSecondary : "transparent",
              borderLeft: f ? `2px solid ${n.colors.primary}` : "2px solid transparent",
              transition: "background-color 100ms ease"
            },
            onMouseEnter: (u) => {
              f || (u.currentTarget.style.backgroundColor = n.colors.backgroundSecondary);
            },
            onMouseLeave: (u) => {
              f || (u.currentTarget.style.backgroundColor = "transparent");
            },
            children: [
              /* @__PURE__ */ l(
                "span",
                {
                  style: {
                    color: n.colors.info,
                    fontFamily: n.fonts.monospace,
                    fontSize: n.fontSizes[1],
                    flexShrink: 0
                  },
                  children: "/"
                }
              ),
              /* @__PURE__ */ b("div", { style: { flex: 1, minWidth: 0 }, children: [
                /* @__PURE__ */ b(
                  "div",
                  {
                    style: {
                      fontFamily: n.fonts.monospace,
                      fontSize: n.fontSizes[1],
                      color: n.colors.text
                    },
                    children: [
                      /* @__PURE__ */ l(
                        he,
                        {
                          text: d.name,
                          matchedIndices: h.matchedOn === d.name ? h.matchedIndices : [],
                          highlightColor: n.colors.primary
                        }
                      ),
                      h.matchedOn !== d.name && /* @__PURE__ */ b(
                        "span",
                        {
                          style: {
                            color: n.colors.textMuted,
                            marginLeft: "8px",
                            fontSize: n.fontSizes[0]
                          },
                          children: [
                            "(alias: ",
                            h.matchedOn,
                            ")"
                          ]
                        }
                      )
                    ]
                  }
                ),
                /* @__PURE__ */ l(
                  "div",
                  {
                    style: {
                      fontSize: n.fontSizes[0],
                      color: n.colors.textMuted,
                      marginTop: "2px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis"
                    },
                    children: d.description
                  }
                )
              ] }),
              d.args && d.args.length > 0 && /* @__PURE__ */ l(
                "div",
                {
                  style: {
                    fontSize: n.fontSizes[0],
                    color: n.colors.textMuted,
                    fontFamily: n.fonts.monospace,
                    flexShrink: 0
                  },
                  children: d.args.map((u, y) => /* @__PURE__ */ b("span", { children: [
                    y > 0 && " ",
                    /* @__PURE__ */ l(
                      "span",
                      {
                        style: {
                          color: u.required ? n.colors.warning : n.colors.textMuted
                        },
                        children: u.required ? `<${u.name}>` : `[${u.name}]`
                      }
                    )
                  ] }, u.name))
                }
              ),
              f && /* @__PURE__ */ l(
                "kbd",
                {
                  style: {
                    padding: "2px 6px",
                    backgroundColor: n.colors.backgroundTertiary,
                    borderRadius: "3px",
                    border: `1px solid ${n.colors.border}`,
                    fontSize: n.fontSizes[0],
                    color: n.colors.textMuted,
                    flexShrink: 0
                  },
                  children: "Tab"
                }
              )
            ]
          },
          `${d.name}-${C}`
        );
      })
    }
  );
};
we.displayName = "QuickCommandAutocomplete";
const Oe = ({
  palette: o,
  config: e
}) => {
  const { theme: t } = ee(), r = U(null), {
    isOpen: s,
    close: i,
    query: a,
    setQuery: n,
    mode: g,
    status: c,
    pendingTools: x,
    completedTools: p,
    agentResponse: h,
    submit: C,
    historyPrevious: f,
    historyNext: d,
    suggestions: u,
    agentAvailable: y,
    // Autocomplete
    quickCommandMatches: L,
    argumentOptionMatches: q,
    parsedQuery: z,
    currentArgDef: A,
    selectedAutocompleteIndex: v,
    autocompleteItemCount: S,
    autocompleteNext: k,
    autocompletePrevious: I,
    autocompleteAccept: W,
    showAutocomplete: $
  } = o;
  E(() => {
    if (!s) return;
    const V = (N) => {
      r.current && !r.current.contains(N.target) && i();
    }, Y = setTimeout(() => {
      document.addEventListener("mousedown", V);
    }, 100);
    return () => {
      clearTimeout(Y), document.removeEventListener("mousedown", V);
    };
  }, [s, i]);
  const [T, P] = _(!1), [B, se] = _(!1);
  if (E(() => {
    if (s)
      se(!0), requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          P(!0);
        });
      });
    else {
      P(!1);
      const V = setTimeout(() => {
        se(!1);
      }, 150);
      return () => clearTimeout(V);
    }
  }, [s]), !B)
    return null;
  const G = y ? (e == null ? void 0 : e.placeholder) || "What would you like to do?" : "Quick command mode (agent unavailable)", K = [...p, ...x], te = K.length > 0, H = h && c !== "idle", M = y && !a && c === "idle" && u.length > 0, oe = !y && g !== "quick-command" && c === "idle";
  return /* @__PURE__ */ b(ce, { children: [
    /* @__PURE__ */ l(
      "div",
      {
        style: {
          position: "fixed",
          inset: 0,
          zIndex: 999
        },
        onClick: i
      }
    ),
    /* @__PURE__ */ b(
      "div",
      {
        ref: r,
        className: e == null ? void 0 : e.className,
        style: {
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          maxHeight: "50vh",
          backgroundColor: t.colors.background,
          borderTop: `1px solid ${t.colors.border}`,
          boxShadow: t.shadows[2],
          zIndex: 1e3,
          display: "flex",
          flexDirection: "column-reverse",
          overflow: "hidden",
          transform: T ? "translateY(0)" : "translateY(100%)",
          transition: "transform 150ms ease-out",
          ...e == null ? void 0 : e.style
        },
        children: [
          /* @__PURE__ */ b("div", { children: [
            /* @__PURE__ */ l(
              xe,
              {
                value: a,
                onChange: n,
                onSubmit: C,
                onClose: i,
                onHistoryPrevious: f,
                onHistoryNext: d,
                mode: g,
                status: c,
                placeholder: G,
                agentAvailable: y,
                showAutocomplete: $,
                autocompleteItemCount: S,
                onAutocompleteNext: k,
                onAutocompletePrevious: I,
                onAutocompleteAccept: W
              }
            ),
            /* @__PURE__ */ b(
              "div",
              {
                style: {
                  padding: "8px 16px",
                  borderTop: `1px solid ${t.colors.border}`,
                  display: "flex",
                  gap: "16px",
                  fontSize: t.fontSizes[0],
                  color: t.colors.textMuted,
                  backgroundColor: t.colors.background
                },
                children: [
                  /* @__PURE__ */ b("span", { children: [
                    /* @__PURE__ */ l(
                      "kbd",
                      {
                        style: {
                          padding: "2px 6px",
                          backgroundColor: t.colors.backgroundSecondary,
                          borderRadius: "3px",
                          border: `1px solid ${t.colors.border}`
                        },
                        children: "Enter"
                      }
                    ),
                    " ",
                    "Execute"
                  ] }),
                  /* @__PURE__ */ b("span", { children: [
                    /* @__PURE__ */ l(
                      "kbd",
                      {
                        style: {
                          padding: "2px 6px",
                          backgroundColor: t.colors.backgroundSecondary,
                          borderRadius: "3px",
                          border: `1px solid ${t.colors.border}`
                        },
                        children: "Esc"
                      }
                    ),
                    " ",
                    "Close"
                  ] }),
                  /* @__PURE__ */ b("span", { children: [
                    /* @__PURE__ */ l(
                      "kbd",
                      {
                        style: {
                          padding: "2px 6px",
                          backgroundColor: t.colors.backgroundSecondary,
                          borderRadius: "3px",
                          border: `1px solid ${t.colors.border}`
                        },
                        children: "↑↓"
                      }
                    ),
                    " ",
                    "History"
                  ] }),
                  /* @__PURE__ */ b("span", { style: { marginLeft: "auto" }, children: [
                    /* @__PURE__ */ l(
                      "kbd",
                      {
                        style: {
                          padding: "2px 6px",
                          backgroundColor: t.colors.backgroundSecondary,
                          borderRadius: "3px",
                          border: `1px solid ${t.colors.border}`
                        },
                        children: "/"
                      }
                    ),
                    " ",
                    "Quick command"
                  ] })
                ]
              }
            )
          ] }),
          /* @__PURE__ */ b("div", { style: { overflow: "auto" }, children: [
            te && /* @__PURE__ */ l(ke, { tools: K, compact: K.length > 3 }),
            H && /* @__PURE__ */ l(
              be,
              {
                response: h,
                streaming: c === "thinking"
              }
            ),
            M && /* @__PURE__ */ b(
              "div",
              {
                style: {
                  padding: "12px 16px",
                  display: "flex",
                  gap: "8px",
                  flexWrap: "wrap"
                },
                children: [
                  /* @__PURE__ */ l(
                    "span",
                    {
                      style: {
                        color: t.colors.textMuted,
                        fontSize: t.fontSizes[0],
                        marginRight: "4px"
                      },
                      children: "Try:"
                    }
                  ),
                  u.map((V, Y) => /* @__PURE__ */ b(
                    "button",
                    {
                      onClick: () => {
                        n(V);
                      },
                      style: {
                        padding: "4px 10px",
                        backgroundColor: t.colors.backgroundSecondary,
                        border: `1px solid ${t.colors.border}`,
                        borderRadius: "12px",
                        color: t.colors.textSecondary,
                        fontSize: t.fontSizes[0],
                        cursor: "pointer",
                        transition: "background-color 150ms ease"
                      },
                      onMouseEnter: (N) => {
                        N.currentTarget.style.backgroundColor = t.colors.backgroundTertiary;
                      },
                      onMouseLeave: (N) => {
                        N.currentTarget.style.backgroundColor = t.colors.backgroundSecondary;
                      },
                      children: [
                        '"',
                        V,
                        '"'
                      ]
                    },
                    Y
                  ))
                ]
              }
            ),
            oe && /* @__PURE__ */ b(
              "div",
              {
                style: {
                  padding: "12px 16px",
                  fontSize: t.fontSizes[0],
                  color: t.colors.warning,
                  display: "flex",
                  alignItems: "center",
                  gap: "8px"
                },
                children: [
                  /* @__PURE__ */ l("span", { children: "Agent unavailable." }),
                  /* @__PURE__ */ b("span", { style: { color: t.colors.textMuted }, children: [
                    "Use quick commands (start with ",
                    /* @__PURE__ */ l("kbd", { style: {
                      padding: "2px 6px",
                      backgroundColor: t.colors.backgroundSecondary,
                      borderRadius: "3px",
                      border: `1px solid ${t.colors.border}`
                    }, children: "/" }),
                    ")"
                  ] })
                ]
              }
            ),
            $ && /* @__PURE__ */ l(
              we,
              {
                matches: L,
                argumentMatches: q,
                currentArg: A,
                isEnteringArgs: z.isEnteringArgs,
                selectedIndex: v,
                onSelect: (V) => {
                  var N;
                  if (z.isEnteringArgs) {
                    const Q = q[V];
                    if (Q) {
                      let re = `/${z.commandName}`;
                      for (const ae of z.enteredArgs)
                        re += ` ${ae}`;
                      re += ` ${Q.option}`;
                      const de = z.currentArgIndex + 1;
                      ((N = z.command) == null ? void 0 : N.args) && de < z.command.args.length && (re += " "), n(re);
                    }
                    return;
                  }
                  const Y = L[V];
                  if (Y) {
                    const Q = Y.command;
                    let re = `/${Q.name}`;
                    Q.args && Q.args.length > 0 && (re += " "), n(re);
                  }
                }
              }
            )
          ] })
        ]
      }
    ),
    /* @__PURE__ */ l("style", { children: `
          @keyframes pulse {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.5; }
          }
          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
          @keyframes blink {
            0%, 100% { opacity: 1; }
            50% { opacity: 0; }
          }
        ` })
  ] });
};
Oe.displayName = "AgentCommandPalette";
function pe(o, e) {
  const t = o.toLowerCase(), r = e.toLowerCase();
  if (!t)
    return { score: 0, matchedIndices: [] };
  const s = [];
  let i = 0, a = 0, n = 0, g = -1;
  for (let c = 0; c < r.length && i < t.length; c++)
    r[c] === t[i] && (s.push(c), g === c - 1 ? (n++, a += n * 2) : n = 1, c === 0 && (a += 10), c > 0 && /[_\-\s]/.test(e[c - 1]) && (a += 5), a += 1, g = c, i++);
  return i < t.length ? null : (a -= e.length * 0.1, t === r && (a += 20), r.startsWith(t) && (a += 15), { score: a, matchedIndices: s });
}
function Ve(o, e, t = 10) {
  const r = o.replace(/^\//, "").trim();
  if (!r)
    return [];
  const s = [];
  for (const i of e) {
    const a = pe(r, i.name);
    if (a) {
      s.push({
        command: i,
        score: a.score,
        matchedIndices: a.matchedIndices,
        matchedOn: i.name
      });
      continue;
    }
    if (i.aliases)
      for (const n of i.aliases) {
        const g = pe(r, n);
        if (g) {
          s.push({
            command: i,
            score: g.score - 2,
            // Slight penalty for alias match
            matchedIndices: g.matchedIndices,
            matchedOn: n
          });
          break;
        }
      }
  }
  return s.sort((i, a) => a.score - i.score).slice(0, t);
}
function Be(o, e) {
  const r = o.replace(/^\//, "").split(/\s+/), s = r[0] || "", i = o.endsWith(" ") && o.trim().length > 0, a = e.find(
    (g) => {
      var c;
      return g.name.toLowerCase() === s.toLowerCase() || ((c = g.aliases) == null ? void 0 : c.some((x) => x.toLowerCase() === s.toLowerCase()));
    }
  ) || null;
  if (!a)
    return {
      commandName: s,
      command: null,
      enteredArgs: [],
      currentArgValue: "",
      currentArgIndex: -1,
      isEnteringArgs: !1
    };
  const n = r.slice(1);
  if (i)
    return {
      commandName: a.name,
      command: a,
      enteredArgs: n,
      currentArgValue: "",
      currentArgIndex: n.length,
      isEnteringArgs: !0
    };
  if (n.length > 0) {
    const g = n.slice(0, -1), c = n[n.length - 1];
    return {
      commandName: a.name,
      command: a,
      enteredArgs: g,
      currentArgValue: c,
      currentArgIndex: g.length,
      isEnteringArgs: !0
    };
  }
  return {
    commandName: a.name,
    command: a,
    enteredArgs: [],
    currentArgValue: "",
    currentArgIndex: -1,
    isEnteringArgs: !1
  };
}
function Ke(o, e, t = 10) {
  if (!e.length)
    return [];
  if (!o)
    return e.slice(0, t).map((s) => ({
      option: s,
      score: 0,
      matchedIndices: []
    }));
  const r = [];
  for (const s of e) {
    const i = pe(o, s);
    i && r.push({
      option: s,
      score: i.score,
      matchedIndices: i.matchedIndices
    });
  }
  return r.sort((s, i) => i.score - s.score).slice(0, t);
}
const He = [
  "hide sidebars",
  "show terminal",
  "focus editor"
];
function yt({
  events: o,
  keyboard: e = { key: "p", altKey: !0 },
  config: t = {},
  onExecuteTool: r,
  initialSuggestions: s = He,
  agentAvailable: i = !0,
  quickCommands: a = []
} = {}) {
  const [n, g] = _(!1), [c, x] = _(""), [p, h] = _("natural"), [C, f] = _("idle"), [d, u] = _([]), [y, L] = _([]), [q, z] = _(""), [A, v] = _([]), [S, k] = _(-1), I = ne(() => s, [s]), [W, $] = _(-1), T = ne(() => p !== "quick-command" || !a.length ? {
    commandName: "",
    command: null,
    enteredArgs: [],
    currentArgValue: "",
    currentArgIndex: -1,
    isEnteringArgs: !1
  } : Be(c, a), [c, p, a]), P = ne(() => p !== "quick-command" || !a.length || T.isEnteringArgs ? [] : Ve(c, a), [c, p, a, T.isEnteringArgs]), B = ne(() => {
    var R;
    if (!T.isEnteringArgs || !((R = T.command) != null && R.args))
      return [];
    const m = T.command.args[T.currentArgIndex];
    return m != null && m.options ? Ke(T.currentArgValue, m.options) : [];
  }, [T]), se = ne(() => {
    var m;
    return !T.isEnteringArgs || !((m = T.command) != null && m.args) ? null : T.command.args[T.currentArgIndex] || null;
  }, [T]), G = ne(() => p !== "quick-command" || C !== "idle" || c.length === 0 ? !1 : P.length > 0 || B.length > 0, [p, C, c.length, P.length, B.length]), K = ne(() => T.isEnteringArgs ? B.length : P.length, [T.isEnteringArgs, B.length, P.length]);
  E(() => {
    $(K > 0 ? 0 : -1);
  }, [K]);
  const te = w((m) => {
    x(m), h(m.startsWith("/") ? "quick-command" : "natural");
  }, []), H = w(() => {
    g(!0), i ? (x(""), h("natural")) : (x("/"), h("quick-command")), f("idle"), u([]), L([]), z(""), k(-1), o == null || o.emit({
      type: "agent-command-palette:opened",
      source: "agent-command-palette",
      timestamp: Date.now(),
      payload: {}
    });
  }, [o, i]), M = w(() => {
    g(!1), o == null || o.emit({
      type: "agent-command-palette:closed",
      source: "agent-command-palette",
      timestamp: Date.now(),
      payload: {}
    });
  }, [o]), oe = w(() => {
    n ? M() : H();
  }, [n, H, M]), V = w(() => {
    x(""), h("natural"), f("idle"), u([]), L([]), z(""), k(-1);
  }, []), Y = w((m) => {
    const R = {
      ...m,
      status: "pending"
    };
    return u((j) => [...j, R]), R;
  }, []), N = w(
    (m, R, j, X) => {
      u((F) => {
        const J = F.find((Z) => Z.id === m);
        if (!J) return F;
        const D = {
          ...J,
          status: R,
          result: j,
          error: X
        };
        return R === "success" || R === "error" ? (L((Z) => [...Z, D]), F.filter((Z) => Z.id !== m)) : F.map((Z) => Z.id === m ? D : Z);
      });
    },
    []
  ), Q = w(
    async (m) => {
      const R = m.replace(/^\//, "").trim().split(/\s+/), j = R[0], X = R.slice(1);
      if (!j) return;
      f("executing");
      const F = `quick-${Date.now()}`;
      Y({
        id: F,
        name: j,
        args: { args: X }
      }), N(F, "running");
      try {
        if (r) {
          const D = await r(j, { args: X });
          N(F, "success", String(D));
        } else
          N(F, "success", "Tool executed (no handler)");
        v((D) => [
          {
            query: m,
            timestamp: Date.now(),
            toolsExecuted: [j],
            success: !0
          },
          ...D.slice(0, (t.maxHistoryEntries || 50) - 1)
        ]), f("complete"), z(`Executed: ${j}`);
        const J = t.autoCloseDelay ?? 1e3;
        J > 0 && setTimeout(() => M(), J);
      } catch (J) {
        const D = J instanceof Error ? J.message : "Unknown error";
        N(F, "error", void 0, D), f("error"), z(`Error: ${D}`);
      }
    },
    [r, Y, N, t.autoCloseDelay, t.maxHistoryEntries, M]
  ), re = w(() => {
    if (c.trim()) {
      if (p === "quick-command") {
        Q(c);
        return;
      }
      if (!i) {
        z("Agent unavailable. Use quick commands (start with /)."), f("error");
        return;
      }
      f("thinking"), o == null || o.emit({
        type: "agent-command-palette:submit",
        source: "agent-command-palette",
        timestamp: Date.now(),
        payload: { query: c, mode: p }
      }), v((m) => [
        {
          query: c,
          timestamp: Date.now(),
          toolsExecuted: [],
          success: !0
        },
        ...m.slice(0, (t.maxHistoryEntries || 50) - 1)
      ]);
    }
  }, [c, p, Q, o, t.maxHistoryEntries, i]), de = w(() => {
    if (A.length === 0) return;
    const m = S < A.length - 1 ? S + 1 : S;
    k(m), A[m] && (x(A[m].query), h(A[m].query.startsWith("/") ? "quick-command" : "natural"));
  }, [A, S]), ue = w(() => {
    if (S <= 0) {
      k(-1), x(""), h("natural");
      return;
    }
    const m = S - 1;
    k(m), A[m] && (x(A[m].query), h(A[m].query.startsWith("/") ? "quick-command" : "natural"));
  }, [A, S]), ae = w(
    (m) => {
      const {
        key: R = "p",
        altKey: j = !0,
        ctrlKey: X = !1,
        metaKey: F = !1,
        shiftKey: J = !1
      } = e, D = m.altKey === j && m.ctrlKey === X && m.metaKey === F && m.shiftKey === J;
      if ((j ? m.code === `Key${R.toUpperCase()}` : m.key.toLowerCase() === R.toLowerCase()) && D) {
        const ie = m.target;
        if (!ie.closest("[data-agent-command-palette-input]") && (ie.tagName === "INPUT" || ie.tagName === "TEXTAREA" || ie.isContentEditable))
          return;
        m.preventDefault(), oe();
      }
    },
    [e, oe]
  );
  E(() => (window.addEventListener("keydown", ae), () => window.removeEventListener("keydown", ae)), [ae]);
  const Le = w(() => {
    G && $(
      (m) => m < K - 1 ? m + 1 : 0
    );
  }, [G, K]), We = w(() => {
    G && $(
      (m) => m > 0 ? m - 1 : K - 1
    );
  }, [G, K]), _e = w((m = !1) => {
    var F;
    if (!G || W < 0) return;
    if (T.isEnteringArgs) {
      const J = B[W];
      if (!J) return;
      let D = `/${T.commandName}`;
      for (const fe of T.enteredArgs)
        D += ` ${fe}`;
      D += ` ${J.option}`;
      const Z = T.currentArgIndex + 1;
      ((F = T.command) == null ? void 0 : F.args) && Z < T.command.args.length ? (D += " ", x(D), $(-1)) : (x(D), $(-1), m && setTimeout(() => Q(D), 0));
      return;
    }
    const R = P[W];
    if (!R) return;
    const j = R.command;
    let X = `/${j.name}`;
    j.args && j.args.length > 0 ? (X += " ", x(X), $(-1)) : (x(X), $(-1), m && setTimeout(() => Q(X), 0));
  }, [G, W, T, B, P, Q]);
  return {
    // Agent availability
    agentAvailable: i,
    // Visibility
    isOpen: n,
    open: H,
    close: M,
    toggle: oe,
    // Input
    query: c,
    setQuery: te,
    mode: p,
    // Execution
    status: C,
    setStatus: f,
    pendingTools: d,
    completedTools: y,
    agentResponse: q,
    setAgentResponse: z,
    submit: re,
    executeQuickCommand: Q,
    // Tool management (for external AI integration)
    addPendingTool: Y,
    updateToolStatus: N,
    // History
    history: A,
    historyPrevious: de,
    historyNext: ue,
    // Suggestions
    suggestions: I,
    // Actions
    clear: V,
    // Quick command autocomplete
    quickCommandMatches: P,
    argumentOptionMatches: B,
    parsedQuery: T,
    currentArgDef: se,
    selectedAutocompleteIndex: W,
    autocompleteItemCount: K,
    autocompleteNext: Le,
    autocompletePrevious: We,
    autocompleteAccept: _e,
    showAutocomplete: G
  };
}
const Se = {
  name: "get_visible_panels",
  description: "Get the current visibility state of all panel slots (left, middle, right). Returns which panels are active in each slot and whether side panels are collapsed.",
  inputs: {
    type: "object",
    properties: {},
    required: []
  },
  outputs: {
    type: "object",
    properties: {
      left: {
        type: "object",
        properties: {
          panelId: {
            type: "string",
            description: "The ID of the panel in the left slot"
          },
          collapsed: {
            type: "boolean",
            description: "Whether the left panel is collapsed"
          },
          size: {
            type: "number",
            description: "Width percentage of the left panel"
          }
        }
      },
      middle: {
        type: "object",
        properties: {
          panelId: {
            type: "string",
            description: "The ID of the panel in the middle slot"
          },
          size: {
            type: "number",
            description: "Width percentage of the middle panel"
          }
        }
      },
      right: {
        type: "object",
        properties: {
          panelId: {
            type: "string",
            description: "The ID of the panel in the right slot"
          },
          collapsed: {
            type: "boolean",
            description: "Whether the right panel is collapsed"
          },
          size: {
            type: "number",
            description: "Width percentage of the right panel"
          }
        }
      },
      workspaceId: {
        type: "string",
        description: "The ID of the currently active workspace layout"
      }
    }
  },
  tags: ["panel", "layout", "visibility", "state", "query"],
  tool_call_template: {
    call_template_type: "panel_event",
    event_type: "panel:get-visibility"
  }
}, ve = {
  name: "get_panel_state",
  description: "Get the current state of a specific panel. Returns panel-specific state data if the panel supports state queries.",
  inputs: {
    type: "object",
    properties: {
      panelId: {
        type: "string",
        description: 'The ID of the panel to query state from (e.g., "file-tree", "terminal")'
      }
    },
    required: ["panelId"]
  },
  outputs: {
    type: "object",
    properties: {
      panelId: { type: "string", description: "The queried panel ID" },
      hasState: {
        type: "boolean",
        description: "Whether the panel supports state queries"
      },
      state: {
        type: "object",
        description: "The panel state (shape depends on the panel)"
      }
    }
  },
  tags: ["panel", "state", "query"],
  tool_call_template: {
    call_template_type: "panel_event",
    event_type: "panel:get-state"
  }
}, Te = {
  name: "list_panels_with_state",
  description: "Get a list of all panels that support state queries. Use this to discover which panels can be queried with get_panel_state.",
  inputs: {
    type: "object",
    properties: {},
    required: []
  },
  outputs: {
    type: "object",
    properties: {
      panels: {
        type: "array",
        items: {
          type: "object",
          properties: {
            panelId: { type: "string", description: "The panel ID" },
            name: { type: "string", description: "The panel display name" },
            description: {
              type: "string",
              description: "Description of the state this panel provides"
            }
          }
        },
        description: "List of panels that support state queries"
      }
    }
  },
  tags: ["panel", "state", "query", "discovery"],
  tool_call_template: {
    call_template_type: "panel_event",
    event_type: "panel:list-state-panels"
  }
}, Ce = {
  name: "toggle_panel",
  description: "Collapse or expand a side panel to give more space to the main content area.",
  inputs: {
    type: "object",
    properties: {
      panel: {
        type: "string",
        enum: ["left", "right"],
        description: 'Which panel to toggle: "left" or "right"'
      }
    },
    required: ["panel"]
  },
  outputs: {
    type: "object",
    properties: {
      success: { type: "boolean" },
      panel: { type: "string" },
      action: { type: "string" }
    }
  },
  tags: ["panel", "layout", "toggle", "collapse", "expand", "sidebar"],
  tool_call_template: {
    call_template_type: "panel_event",
    event_type: "panel:toggle"
  }
}, Ie = {
  name: "collapse_all_panels",
  description: "Collapse both left and right panels to maximize the main content area. Useful for focus mode.",
  inputs: {
    type: "object",
    properties: {},
    required: []
  },
  outputs: {
    type: "object",
    properties: {
      success: { type: "boolean" },
      action: { type: "string" }
    }
  },
  tags: ["panel", "layout", "collapse", "focus", "maximize"],
  tool_call_template: {
    call_template_type: "panel_event",
    event_type: "panel:collapse-all"
  }
}, $e = {
  name: "expand_all_panels",
  description: "Expand both left and right panels to show all content. Restores the default layout.",
  inputs: {
    type: "object",
    properties: {},
    required: []
  },
  outputs: {
    type: "object",
    properties: {
      success: { type: "boolean" },
      action: { type: "string" }
    }
  },
  tags: ["panel", "layout", "expand", "restore", "show"],
  tool_call_template: {
    call_template_type: "panel_event",
    event_type: "panel:expand-all"
  }
}, Ae = {
  name: "switch_panel",
  description: "Change which content is displayed in a panel slot (left, middle, or right).",
  inputs: {
    type: "object",
    properties: {
      slot: {
        type: "string",
        enum: ["left", "middle", "right"],
        description: 'Which slot to change: "left", "middle", or "right"'
      },
      panel: {
        type: "string",
        description: "The panel ID to display in the slot"
      }
    },
    required: ["slot", "panel"]
  },
  outputs: {
    type: "object",
    properties: {
      success: { type: "boolean" },
      slot: { type: "string" },
      panel: { type: "string" }
    }
  },
  tags: ["panel", "layout", "switch", "navigation", "view"],
  tool_call_template: {
    call_template_type: "panel_event",
    event_type: "panel:switch"
  }
}, ze = {
  name: "focus_panel",
  description: "Set focus to a specific panel slot for keyboard navigation.",
  inputs: {
    type: "object",
    properties: {
      slot: {
        type: "string",
        enum: ["left", "middle", "right"],
        description: 'Which slot to focus: "left", "middle", or "right"'
      }
    },
    required: ["slot"]
  },
  outputs: {
    type: "object",
    properties: {
      success: { type: "boolean" },
      slot: { type: "string" }
    }
  },
  tags: ["panel", "focus", "navigation", "keyboard"],
  tool_call_template: {
    call_template_type: "panel_event",
    event_type: "panel:focus"
  }
}, Pe = {
  name: "reset_layout",
  description: "Reset panel sizes to the default layout configuration.",
  inputs: {
    type: "object",
    properties: {},
    required: []
  },
  outputs: {
    type: "object",
    properties: {
      success: { type: "boolean" },
      action: { type: "string" }
    }
  },
  tags: ["panel", "layout", "reset", "default", "restore"],
  tool_call_template: {
    call_template_type: "panel_event",
    event_type: "panel:reset-layout"
  }
}, Qe = [
  // State query tools
  Se,
  ve,
  Te,
  // Layout action tools
  Ce,
  Ie,
  $e,
  Ae,
  ze,
  Pe
], xt = [
  Se,
  ve,
  Te
], kt = [
  Ce,
  Ie,
  $e,
  Ae,
  ze,
  Pe
], bt = {
  id: "panel-layouts",
  name: "Panel Layouts",
  description: "Generic panel layout and state query operations",
  tools: Qe
};
function Je(o) {
  const e = {};
  if (o.inputs.properties)
    for (const [t, r] of Object.entries(o.inputs.properties)) {
      const s = r;
      e[t] = {
        type: s.type || "string",
        description: s.description,
        ...s.enum && { enum: s.enum }
      };
    }
  return {
    name: o.name,
    description: o.description,
    parameters: {
      type: "object",
      properties: e,
      required: o.inputs.required || []
    }
  };
}
function wt(o) {
  return {
    functionDeclarations: o.map(Je)
  };
}
function Ue(o) {
  return {
    type: "function",
    function: {
      name: o.name,
      description: o.description,
      parameters: o.inputs
    }
  };
}
function St(o) {
  return o.map(Ue);
}
function Ye(o) {
  return {
    name: o.name,
    description: o.description,
    input_schema: o.inputs
  };
}
function vt(o) {
  return o.map(Ye);
}
function Ge(o) {
  return {
    name: o.name,
    description: o.description,
    parameters: o.inputs
  };
}
function Tt(o) {
  return o.map(Ge);
}
function Ct(o, e = {}) {
  const {
    header: t = "You have access to the following tools:",
    includeParameters: r = !0
  } = e, s = o.map((i) => {
    let a = `- ${i.name}: ${i.description}`;
    if (r && i.inputs.properties) {
      const n = Object.entries(i.inputs.properties).map(([g, c]) => {
        var h;
        const x = c, p = (h = i.inputs.required) != null && h.includes(g) ? " (required)" : "";
        return `    - ${g}: ${x.description || x.type}${p}`;
      }).join(`
`);
      n && (a += `
${n}`);
    }
    return a;
  });
  return `${t}

${s.join(`

`)}`;
}
const Xe = ({ size: o = 18 }) => /* @__PURE__ */ b(
  "svg",
  {
    width: o,
    height: o,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: [
      /* @__PURE__ */ l("rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }),
      /* @__PURE__ */ l("path", { d: "M9 3v18" })
    ]
  }
), Ze = ({ size: o = 18 }) => /* @__PURE__ */ b(
  "svg",
  {
    width: o,
    height: o,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: [
      /* @__PURE__ */ l("rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }),
      /* @__PURE__ */ l("path", { d: "M9 3v18" }),
      /* @__PURE__ */ l("path", { d: "m16 15-3-3 3-3" })
    ]
  }
), et = ({ size: o = 18 }) => /* @__PURE__ */ b(
  "svg",
  {
    width: o,
    height: o,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: [
      /* @__PURE__ */ l("rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }),
      /* @__PURE__ */ l("path", { d: "M15 3v18" })
    ]
  }
), tt = ({ size: o = 18 }) => /* @__PURE__ */ b(
  "svg",
  {
    width: o,
    height: o,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: [
      /* @__PURE__ */ l("rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }),
      /* @__PURE__ */ l("path", { d: "M15 3v18" }),
      /* @__PURE__ */ l("path", { d: "m8 9 3 3-3 3" })
    ]
  }
), me = ({
  isCollapsed: o,
  onToggle: e,
  side: t = "left",
  iconSize: r = 18,
  style: s,
  shortcutHint: i = "Cmd/Ctrl+B",
  title: a,
  className: n
}) => {
  const { theme: g } = ee(), c = () => t === "right" ? o ? /* @__PURE__ */ l(et, { size: r }) : /* @__PURE__ */ l(tt, { size: r }) : o ? /* @__PURE__ */ l(Xe, { size: r }) : /* @__PURE__ */ l(Ze, { size: r });
  return /* @__PURE__ */ l(
    "button",
    {
      onClick: e,
      title: a ?? `${o ? "Show" : "Hide"} ${t === "right" ? "Right Panel" : "Sidebar"}${i ? ` (${i})` : ""}`,
      className: n,
      style: {
        background: "transparent",
        border: "none",
        color: o ? g.colors.textSecondary : g.colors.primary,
        cursor: "pointer",
        padding: "6px",
        borderRadius: "4px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "all 0.2s",
        width: "32px",
        height: "32px",
        ...s
      },
      onMouseEnter: (p) => {
        p.currentTarget.style.backgroundColor = g.colors.backgroundTertiary, p.currentTarget.style.color = g.colors.primary;
      },
      onMouseLeave: (p) => {
        p.currentTarget.style.backgroundColor = "transparent", p.currentTarget.style.color = o ? g.colors.textSecondary : g.colors.primary;
      },
      children: c()
    }
  );
}, ot = ({ size: o = 14 }) => /* @__PURE__ */ b(
  "svg",
  {
    width: o,
    height: o,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: [
      /* @__PURE__ */ l("path", { d: "M8 3 4 7l4 4" }),
      /* @__PURE__ */ l("path", { d: "M4 7h16" }),
      /* @__PURE__ */ l("path", { d: "m16 21 4-4-4-4" }),
      /* @__PURE__ */ l("path", { d: "M20 17H4" })
    ]
  }
), rt = ({ size: o = 14 }) => /* @__PURE__ */ b(
  "svg",
  {
    width: o,
    height: o,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: [
      /* @__PURE__ */ l("path", { d: "m16 3 4 4-4 4" }),
      /* @__PURE__ */ l("path", { d: "M20 7H4" }),
      /* @__PURE__ */ l("path", { d: "m8 21-4-4 4-4" }),
      /* @__PURE__ */ l("path", { d: "M4 17h16" })
    ]
  }
), ye = ({
  onSwitch: o,
  variant: e = "left-middle",
  iconSize: t = 14,
  style: r,
  title: s,
  className: i
}) => {
  const { theme: a } = ee(), n = () => e === "left-middle" ? "Switch left and middle panels" : "Switch right and middle panels", g = e === "left-middle" ? ot : rt;
  return /* @__PURE__ */ l(
    "button",
    {
      onClick: o,
      title: s ?? n(),
      className: i,
      style: {
        background: "transparent",
        border: "none",
        color: a.colors.textSecondary,
        cursor: "pointer",
        padding: "6px",
        borderRadius: "4px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "all 0.2s",
        width: "32px",
        height: "32px",
        ...r
      },
      onMouseEnter: (c) => {
        c.currentTarget.style.backgroundColor = a.colors.backgroundTertiary, c.currentTarget.style.color = a.colors.text;
      },
      onMouseLeave: (c) => {
        c.currentTarget.style.backgroundColor = "transparent", c.currentTarget.style.color = a.colors.textSecondary;
      },
      children: /* @__PURE__ */ l(g, { size: t })
    }
  );
}, nt = ({ size: o = 14 }) => /* @__PURE__ */ b(
  "svg",
  {
    width: o,
    height: o,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: [
      /* @__PURE__ */ l("rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }),
      /* @__PURE__ */ l("path", { d: "M3 9h18" }),
      /* @__PURE__ */ l("path", { d: "M9 21V9" })
    ]
  }
), st = ({
  onConfigure: o,
  iconSize: e = 14,
  style: t,
  title: r = "Configure panel layout",
  className: s
}) => {
  const { theme: i } = ee();
  return /* @__PURE__ */ l(
    "button",
    {
      onClick: o,
      title: r,
      className: s,
      style: {
        background: "transparent",
        border: "none",
        color: i.colors.textSecondary,
        cursor: "pointer",
        padding: "6px",
        borderRadius: "4px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "all 0.2s",
        width: "32px",
        height: "32px",
        ...t
      },
      onMouseEnter: (a) => {
        a.currentTarget.style.backgroundColor = i.colors.backgroundTertiary, a.currentTarget.style.color = i.colors.text;
      },
      onMouseLeave: (a) => {
        a.currentTarget.style.backgroundColor = "transparent", a.currentTarget.style.color = i.colors.textSecondary;
      },
      children: /* @__PURE__ */ l(nt, { size: e })
    }
  );
}, It = ({
  leftSidebarCollapsed: o = !1,
  onToggleLeftSidebar: e,
  showLeftSidebarControl: t = !1,
  rightSidebarCollapsed: r = !1,
  onToggleRightSidebar: s,
  showRightSidebarControl: i = !1,
  onSwitchLeftMiddlePanels: a,
  showSwitchLeftMiddle: n = !1,
  onSwitchRightMiddlePanels: g,
  showSwitchRightMiddle: c = !1,
  onConfigurePanels: x,
  showConfigureButton: p = !1,
  gap: h = 4,
  style: C,
  className: f,
  iconSize: d,
  leftCollapseButtonProps: u,
  rightCollapseButtonProps: y,
  leftMiddleSwitchButtonProps: L,
  rightMiddleSwitchButtonProps: q,
  configureButtonProps: z
}) => t && e || n && a || p && x || c && g || i && s ? /* @__PURE__ */ b(
  "div",
  {
    className: f,
    style: {
      display: "flex",
      alignItems: "center",
      gap: `${h}px`,
      ...C
    },
    children: [
      t && e && /* @__PURE__ */ l(
        me,
        {
          isCollapsed: o,
          onToggle: e,
          side: "left",
          iconSize: d ?? 18,
          ...u
        }
      ),
      n && a && /* @__PURE__ */ l(
        ye,
        {
          onSwitch: a,
          variant: "left-middle",
          iconSize: d ?? 14,
          ...L
        }
      ),
      p && x && /* @__PURE__ */ l(
        st,
        {
          onConfigure: x,
          iconSize: d ?? 14,
          ...z
        }
      ),
      c && g && /* @__PURE__ */ l(
        ye,
        {
          onSwitch: g,
          variant: "right-middle",
          iconSize: d ?? 14,
          ...q
        }
      ),
      i && s && /* @__PURE__ */ l(
        me,
        {
          isCollapsed: r,
          onToggle: s,
          side: "right",
          iconSize: d ?? 18,
          ...y
        }
      )
    ]
  }
) : null;
export {
  xe as AgentCommandInput,
  Oe as AgentCommandPalette,
  be as AgentResponseDisplay,
  zt as EditableConfigurablePanelLayout,
  ht as FocusIndicator,
  mt as FocusModeOverlay,
  De as LocalStoragePersistenceAdapter,
  Me as LocalStorageWorkspaceAdapter,
  me as PanelCollapseButton,
  st as PanelConfigureButton,
  It as PanelControls,
  ye as PanelSwitchButton,
  we as QuickCommandAutocomplete,
  Pt as ResponsiveConfigurablePanelLayout,
  ke as ToolExecutionList,
  O as WorkspaceLayoutService,
  Ie as collapseAllPanelsTool,
  $e as expandAllPanelsTool,
  ze as focusPanelTool,
  pe as fuzzyMatch,
  Ct as generateToolsSystemPrompt,
  ve as getPanelStateTool,
  Se as getVisiblePanelsTool,
  kt as layoutActionTools,
  Qe as layoutTools,
  bt as layoutToolsMetadata,
  Te as listPanelsWithStateTool,
  Lt as mapThemeToPanelVars,
  Wt as mapThemeToTabVars,
  Pe as resetLayoutTool,
  Ve as searchQuickCommands,
  xt as stateQueryTools,
  Ae as switchPanelTool,
  Ce as togglePanelTool,
  Ge as toolToAIFunction,
  Ye as toolToAnthropicFormat,
  Je as toolToGeminiFunction,
  Ue as toolToOpenAIFunction,
  Tt as toolsToAIFunctions,
  vt as toolsToAnthropicFormat,
  wt as toolsToGeminiFormat,
  St as toolsToOpenAIFormat,
  yt as useAgentCommandPalette,
  ut as usePanelFocus,
  gt as usePanelFocusListener,
  ft as usePanelKeyboardShortcuts,
  dt as usePanelPersistence,
  pt as useWorkspace
};
//# sourceMappingURL=index.esm.js.map
